import React, { useContext, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import coverSrc from 'assets/img/generic/7.jpg';
import avatar from 'assets/img/team/y4-avata.png';
import Flex from 'components/common/Flex';
import VerifiedBadge from 'components/common/VerifiedBadge';
import ProfileBanner from 'components/pages/user/ProfileBanner';
import { Trans } from 'react-i18next';
import DataContext from 'y4/context/DataContext';

const Banner = () => {
  const [rightSidedItems] = useState([]);
  const {
    globalData: {
      authentication: { user, userName, userHeadImage, userFullName }
    }
  } = useContext(DataContext);

  return (
    <ProfileBanner>
      <ProfileBanner.Header
        avatar={userHeadImage ? userHeadImage : avatar}
        coverSrc={coverSrc}
      />
      <ProfileBanner.Body>
        <Row>
          <Col lg={8}>
            <h4 className="mb-1">
              {userName}
              <VerifiedBadge />
            </h4>
            {!userFullName || userName == userFullName ? null : (
              <h5 className="fs-0 fw-normal">{userFullName}</h5>
            )}
            {user == userName ? null : (
              <p className="text-500">
                <Trans ns="auth">Email address</Trans>: {user}
              </p>
            )}
            {/**
            <Button variant="falcon-primary" size="sm" className="px-3">
              Following
            </Button>
            <Button variant="falcon-default" size="sm" className="px-3 ms-2">
              Message
            </Button>
            */}
            <div className="border-dashed border-bottom my-4 d-lg-none" />
          </Col>
          <Col className="ps-2 ps-lg-3">
            {/**
            <Link to="#!">
              <Flex alignItems="center" className="mb-2">
                <FontAwesomeIcon
                  icon="user-circle"
                  className="fs-3 me-2 text-700"
                />
                <div className="flex-1">
                  <h6 className="mb-0">See followers (330)</h6>
                </div>
              </Flex>
            </Link>
            */}
            {rightSidedItems.map(item => (
              <Link to="#!" key={item.title}>
                <Flex alignItems="center" className="mb-2">
                  <img
                    src={item.image}
                    alt={item.title}
                    width={30}
                    className="me-2"
                  />
                  <div className="flex-1">
                    <h6 className="mb-0">{item.title}</h6>
                  </div>
                </Flex>
              </Link>
            ))}
          </Col>
        </Row>
      </ProfileBanner.Body>
    </ProfileBanner>
  );
};

export default Banner;
